import React from 'react'

const TitleContentColumns = ({ title, children }) => {
  return(
    <div className='card card-transparent'>
      <div className='card-block d-flex flex-wrap'>
        <div className='col-lg-3 no-padding'>
          <div className='p-r-30'>
            <h4>{title}</h4>
          </div>
        </div>
        <div className='col-lg-9 no-padding'>
          {children}
        </div>
      </div>
    </div>
  )
}

export default TitleContentColumns
